import { render, staticRenderFns } from "./IndexReward.vue?vue&type=template&id=5ebf2411&scoped=true&"
import script from "./IndexReward.vue?vue&type=script&lang=js&"
export * from "./IndexReward.vue?vue&type=script&lang=js&"
import style0 from "./IndexReward.vue?vue&type=style&index=0&id=5ebf2411&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebf2411",
  null
  
)

export default component.exports